import { PageToolbar } from '@app/components/page-toolbar/PageToolbar';
import { PageToolbarLinearProgress } from '@app/components/page-toolbar/PageToolbarLinearProgress';
import { Divider } from '@mui/material';
import { ActionsBar } from './ActionsBar';
import { FilterBar } from './FilterBar';
import { useListViewContext } from './context/ListViewContext';

/**
 * Toolbar component that contains the filter bar and actions bar.
 */
export function DataToolbar({
  actions,
  onExport,
  onRefresh,
  total,
  isLoading,
  showProgress = false,
}: {
  actions: React.ReactNode[];
  onExport?: (format: 'csv' | 'xls') => Promise<unknown>;
  onRefresh: () => void;
  total: number;
  isLoading: boolean;
  showProgress?: boolean;
}) {
  const { filters } = useListViewContext();

  return (
    <>
      <PageToolbar>
        {!!filters.length && <FilterBar />}
        {!!filters.length && <Divider sx={{ my: 1.25 }} />}
        <ActionsBar
          actions={actions}
          onRefresh={onRefresh}
          onExport={onExport}
          total={total}
          isLoading={isLoading}
        />
        {showProgress && <PageToolbarLinearProgress visible={isLoading} />}
      </PageToolbar>
    </>
  );
}
